import { render, staticRenderFns } from "./SimpleVideo.vue?vue&type=template&id=a1dac006"
import script from "./SimpleVideo.vue?vue&type=script&lang=js"
export * from "./SimpleVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports